// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2p0AN","ranges":"BmiRanges_ranges__39bgZ"};